import { render, staticRenderFns } from "./DimLoading.vue?vue&type=template&id=561bb370&scoped=true&lang=pug&"
import script from "./DimLoading.vue?vue&type=script&lang=ts&"
export * from "./DimLoading.vue?vue&type=script&lang=ts&"
import style0 from "./DimLoading.vue?vue&type=style&index=0&id=561bb370&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561bb370",
  null
  
)

export default component.exports